<ion-label color="dark" class="!text-base flex items-center ml-4 mt-4">{{ 'HOME.ACCOUNT_NUMBER' | transloco }} :
  <ion-text *ngIf="!busy; else loadingState" class="copyable-text p-2 rounded flex items-center cursor-pointer !ml-1 !text-base" (click)="copyToClipboard()">{{ accountNumber }}
    <ion-icon name="copy-outline" class="ml-2"></ion-icon>
  </ion-text>
  <ng-template #loadingState>
    <ion-skeleton-text class="!text-base !ml-1 p-2 w-28" [animated]="true"></ion-skeleton-text>
  </ng-template>
</ion-label>